import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
    selector: 'ridango-ui-skeleton-loader',
    templateUrl: './skeleton-loader.component.html',
    styleUrls: ['./skeleton-loader.component.scss']
})
export class RidangoUiSkeletonLoaderComponent implements OnInit {
    @Input() animation: string;
    @Input() count: string;
    @Input() theme: any;
    @Input() appearance: any;
    @Input() ariaLabel: string;
    @Input() height: string;
    @Input() width: string;
    @Input() margin: string;
    constructor(
        private liveAnnouncer: LiveAnnouncer,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        const message = this.translate.instant(this.ariaLabel ? this.ariaLabel : 'CONTENT_LOADING_PLEASE_WAIT');
        this.liveAnnouncer.announce(message);
    }
}
